import React from 'react';


export default class AutocompleteResult extends React.Component {

    render() {
        return (
            <a href={this.props.href} className={`row column expanded autocomplete-result autocomplete-result--${this.props.sassPrefix}`}>
                <i className={`${this.props.logoClass}`} aria-hidden="true"></i>
                <span className="autocomplete-result__name">{this.props.name}</span>
            </a>
        );
    }

}